import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import PageWrapper from './components/PageWrapper';

const Login = () => {
  const { signInWithGoogle, signInWithEmail, signUpWithEmail, resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setMessage('');
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    try {
      await signInWithEmail(email, password);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleRegister = async () => {
    setError('');
    setMessage('');
    if (!email || !password || !confirmPassword) {
      setError('All fields are required.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      await signUpWithEmail(email, password);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    if (googleLoading) return;
    setGoogleLoading(true);
    setError('');
    setMessage('');
    try {
      await signInWithGoogle();
    } catch (err) {
      setError("Google Sign-In failed: " + err.message);
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setMessage('');
    if (!email) {
      setError('Please enter your email to reset your password.');
      return;
    }
    try {
      await resetPassword(email);
      setMessage('Password reset email sent.');
    } catch (err) {
      setError('Reset failed: ' + err.message);
    }
  };

  return (
    <PageWrapper>

  
      <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
        <h2>{isRegistering ? 'Register New Account' : 'Sign In'}</h2>

        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        {message && <div style={{ color: 'green', marginBottom: '10px' }}>{message}</div>}

        <button
          onClick={handleGoogleSignIn}
          style={{ marginBottom: '10px', width: '100%' }}
          disabled={googleLoading}
        >
          {googleLoading ? 'Signing in with Google...' : 'Sign in with Google'}
        </button>
        <hr />

        <input
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ width: '100%', margin: '5px 0' }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ width: '100%', margin: '5px 0' }}
        />

        {!isRegistering && (
          <div style={{ marginTop: '5px', textAlign: 'right' }}>
            <button
              onClick={handleResetPassword}
              style={{
                background: 'none',
                border: 'none',
                color: '#007bff',
                cursor: 'pointer',
                fontSize: '0.9rem',
                padding: 0
              }}
            >
              Forgot password?
            </button>
          </div>
        )}

        {isRegistering && (
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            style={{ width: '100%', margin: '5px 0' }}
          />
        )}

        <button
          onClick={isRegistering ? handleRegister : handleLogin}
          style={{ marginTop: '10px', width: '100%' }}
        >
          {isRegistering ? 'Create Account' : 'Login with Email'}
        </button>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={() => {
              setIsRegistering(!isRegistering);
              setError('');
              setMessage('');
              setEmail('');
              setPassword('');
              setConfirmPassword('');
            }}
            style={{
              backgroundColor: '#e0e0e0',
              color: '#222',
              border: '1px solid #aaa',
              padding: '10px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              width: '100%',
              maxWidth: '220px',
            }}
          >
            {isRegistering ? '← Back to Login' : 'Register New Account →'}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Login;
